import React, { MutableRefObject, useMemo, useState } from 'react';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { hideSearchBar, showSearchBar } from 'store/slices/searchBar';
import { closeNavMenu, closeProfileMenu, openNavMenu } from 'store/slices/menu';
import { clearSearchByName, generateSampleSearch } from 'store/slices/location';
import { NavigableStepComponent, Step } from './NavigableStepComponent';
import { HelpTypes } from '../../store/slices/help';

export const ExploreTutorial: React.FC<{
    onShapeChange: (shape: 'circle' | 'square') => void;
    onClickHoleRef: MutableRefObject<() => void>;
}> = ({ onShapeChange, onClickHoleRef }) => {
    const dispatch = useAppDispatch();
    const [index, setIndex] = useState(0);

    const steps = useMemo<Step[]>(
        () => [
            {
                message: {
                    xs: 'Click the menu icon',
                    md: 'Click the \'Search\' option',
                },
                type: HelpTypes.INFORMATION,
                shape: 'circle',
                visible: true,
                onShow: () => {
                    dispatch(hideSearchBar());
                    dispatch(closeProfileMenu());
                    dispatch(closeNavMenu());
                },
            },
            {
                message: 'Click the \'Search\' option',
                type: HelpTypes.INFORMATION,
                shape: 'square',
                visible: { sm: true, md: false },
                onShow: () => dispatch(openNavMenu()),
                onHide: () => dispatch(closeNavMenu()),
            },
            {
                message: 'Enter an address or place and click \'Search\'',
                type: HelpTypes.INFORMATION,
                shape: 'square',
                visible: true,
                onShow: () => dispatch(showSearchBar()),
                onHide: () => dispatch(hideSearchBar()),
            },
            {
                message: 'Once the results are available, select the most accurate option.',
                type: HelpTypes.INFORMATION,
                shape: 'square',
                visible: true,
                onShow: () => {
                    dispatch(showSearchBar());
                    dispatch(generateSampleSearch());
                },
                onHide: () => {
                    dispatch(hideSearchBar());
                    dispatch(clearSearchByName());
                },
            },
        ],
        [dispatch]
    );

    return (
        <NavigableStepComponent
            steps={steps}
            index={index}
            setIndex={setIndex}
            onClose={() => setIndex(0)}
            onShapeChange={onShapeChange}
            onClickHoleRef={onClickHoleRef}
        />
    );
};
